import { TokenOrigin } from "../support/SDKTokenOrigin";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Definitions
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class Token {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, versionId, properties, propertyValues, empty = false) {
        var _a, _b, _c;
        if (empty) {
            // For creation of empty token to be filled from the outside
            return;
        }
        this.id = model.persistentId;
        this.idInVersion = model.id;
        this.brandId = model.brandId;
        this.themeId = null; // Can only be set outside
        this.designSystemVersionId = versionId;
        this.collectionId = (_a = model.collectionId) !== null && _a !== void 0 ? _a : null;
        if (model.meta) {
            this.name = model.meta.name;
            this.description = model.meta.description;
        }
        this.tokenType = model.type;
        this.origin = model.originStyle ? new TokenOrigin(model.originStyle) : null;
        // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
        this.parentGroupId = null;
        this.tokenPath = null;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
        // Set unordered when constructing
        this.sortOrder = (_c = (_b = model.originStyle) === null || _b === void 0 ? void 0 : _b.sortOrder) !== null && _c !== void 0 ? _c : -1;
        this.properties = properties;
        this.propertyValues = {};
        for (const value of propertyValues) {
            if (value.targetElementId === this.id) {
                // Property value refers to this element
                for (const property of properties) {
                    if (property.id === value.definitionId) {
                        // Property value refers to the correct property, we get codeName from it and add it to quick-access
                        this.propertyValues[property.codeName] = value.value;
                    }
                }
            }
        }
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Manipulation
    setParentGroupId(parentGroupId) {
        // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
        this.parentGroupId = parentGroupId !== null && parentGroupId !== void 0 ? parentGroupId : null;
    }
    setTokenPath(tokenPath) {
        this.tokenPath = tokenPath;
    }
    setSortOrder(order) {
        this.sortOrder = order;
    }
    toBaseWriteObject() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return {
            id: this.idInVersion,
            brandId: this.brandId,
            designSystemVersionId: this.designSystemVersionId,
            persistentId: this.id,
            type: this.tokenType,
            meta: {
                name: this.name,
                description: (_a = this.description) !== null && _a !== void 0 ? _a : "",
            },
            originStyle: this.origin && this.origin.id && this.origin.sourceId
                ? {
                    id: (_b = this.origin.id) !== null && _b !== void 0 ? _b : undefined,
                    name: (_c = this.origin.name) !== null && _c !== void 0 ? _c : undefined,
                    sourceId: (_d = this.origin.sourceId) !== null && _d !== void 0 ? _d : undefined,
                    referenceOriginId: (_e = this.origin.referenceOriginId) !== null && _e !== void 0 ? _e : undefined,
                    referencePersistentId: (_f = this.origin.referencePersistentId) !== null && _f !== void 0 ? _f : undefined,
                    referenceResolutionFailed: (_g = this.origin.referenceResolutionFailed) !== null && _g !== void 0 ? _g : undefined,
                    referenceOriginRemote: (_h = this.origin.referenceOriginRemote) !== null && _h !== void 0 ? _h : undefined,
                    referenceOriginName: (_j = this.origin.referenceOriginName) !== null && _j !== void 0 ? _j : undefined,
                    key: (_k = this.origin.key) !== null && _k !== void 0 ? _k : undefined,
                }
                : undefined,
            customPropertyOverrides: [],
            // @ts-expect-error TS(2322): Type 'undefined' is not assignable to type '{ alia... Remove this comment to see the full error message
            data: undefined,
        };
    }
    toWriteObject() {
        throw Error("Unable to write generic token");
    }
}
